export default __webpack_public_path__ + "static/media/discountperIcon.24d99770.svg";